import React, {useState, useEffect} from 'react';
import styled from 'styled-components';
import {Container} from '../styles/Grids';
import {breakPoint} from '../styles/var';
import {cover} from '../data';
import ModelProvider from '../components/modalContext';
import Img from '../components/Img';
import VoteModal from '../components/VoteModal'
import CoverCard from '../components/CoverCard';
import {getRecord} from '../api/voteApi';

import img_title from '../assets/img/pc03-2.png';
import img_1 from '../assets/img/1.png';
import img_2 from '../assets/img/2.png';
import img_3 from '../assets/img/3.png';



const ContentStyles = styled.div`
  position: relative;
  z-index: 2;
  .container {
    padding: 4rem 2rem;
  }
  
  .fixed-img {
    position: absolute;
  }
  .img-1 {
    top: 2%;
    right: 0;
    width: 250px;
  }
  
  .img-2 {
    top: 24%;
    left: 14%;
    width: 188px;
  }
  
  .img-3 {
    bottom: -1%;
    right: 8%;
    transform: translateY(50%);
    width: 317px;
  }

  @media (min-width: ${breakPoint.min}) {
    .container {
      padding-top: 8rem;

      > .title {
        width: 70%;
        margin-left: 0;
      }
    }

    .desc {
      width: 76%;
      margin-left: auto;
    }
  }
  @media (max-width: ${breakPoint.smMax}) {
    .img-1 {
      width: 48px;
    }

    .img-2 {
      top: 16%;
      left: 0;
      width: 45px;
    }

    .img-3 {
      width: 95px;
    }
  }
`;

const PostsGridStyles = styled.div`
  display: grid;
  --column: repeat(2, 1fr);
  --gap: 3rem 2rem;
  grid-template-columns: var(--column);
  gap: var(--gap);

  @media (min-width: ${breakPoint.min}) {
    --column: repeat(4, 1fr);
    margin-top: 6rem;
  }
  @media (min-width: ${breakPoint.lgMin}) {
    --gap: 4rem 3rem;
    --column: repeat(5, 1fr);
  }
`;
const Section2 = (props) => {
    const [state, setState] = useState({
        isShow: false,
        voteId: 1,
    })

    const [voteMap, setVoteMap] = useState({});
    const handleShowModal = (show = true, id = 0) => {
        if (Date.now() > 1662307199000) {
            alert('投票已結束');
        } else {
            setState({
                isShow: show,
                voteId: id
            })
        }

    }


    const getRecordApi = async () => {
      const record = {
	data: [{"id":5,"vote_type":1,"votes":1994},{"id":12,"vote_type":1,"votes":1618},{"id":2,"vote_type":1,"votes":2242},{"id":7,"vote_type":1,"votes":1635},{"id":3,"vote_type":1,"votes":1861},{"id":11,"vote_type":1,"votes":1836},{"id":19,"vote_type":1,"votes":1745},{"id":10,"vote_type":1,"votes":1622},{"id":1,"vote_type":1,"votes":1653},{"id":9,"vote_type":1,"votes":1656},{"id":14,"vote_type":1,"votes":1598},{"id":15,"vote_type":1,"votes":1604},{"id":17,"vote_type":1,"votes":1646},{"id":4,"vote_type":1,"votes":1601},{"id":13,"vote_type":1,"votes":1589},{"id":18,"vote_type":1,"votes":1593},{"id":8,"vote_type":1,"votes":1586},{"id":16,"vote_type":1,"votes":1606},{"id":6,"vote_type":1,"votes":1589},{"id":20,"vote_type":1,"votes":1584}]
      };
      const recordMap = {};
      if (record.data.length > 0) {
        record.data.forEach(item => {
          recordMap[item.id] = item.votes;
        })
      }
      setVoteMap(recordMap);
    }
    useEffect(() => {
      getRecordApi();
    }, [])
    return (
        <ModelProvider value={{...state, handleShowModal}}>
            <ContentStyles {...props}>
                <Img src={img_1} wrapProps={{className: 'fixed-img img-1'}}/>
                <Img src={img_2} wrapProps={{className: 'fixed-img img-2'}}/>
                <Img src={img_3} wrapProps={{className: 'fixed-img img-3'}}/>
                <Container className="container">
                    <Img src={img_title} wrapProps={{className: 'title'}}/>
                    <div className="desc">
                        <p>每一期媽媽寶寶封面都希望呈現有溫度又具時尚感的家庭氛圍！<br/>
                            陸陸續續邀請了許多藝名人一同傳遞愛與溫暖，哪一期的雜誌封面是你最喜歡的呢？馬上投票告訴我們吧！投票就有機會把好禮帶回家唷！
                        </p>
                    </div>
                    <PostsGridStyles className="animate__animated animate__fadeInUp animate__faster">
                        {cover.map(item => {
                            const _vote = voteMap.hasOwnProperty(item.id) ? voteMap[item.id] : 0;
                            return <CoverCard
                                key={item.id}
                                info={item}
                                vote={_vote}
                                handleShowModal={() => handleShowModal(true, item.id)}
                            />
                        })}
                    </PostsGridStyles>
                    <VoteModal className={"theme-secondary"} voteType={1} getRecordApi={getRecordApi}/>
                </Container>
            </ContentStyles>
        </ModelProvider>

    )
};

export default Section2;
